import { Directive, HostListener, Input } from '@angular/core';
import { ScrollService } from './scroll.service';

@Directive({
  selector: '[scrollAnchor]'
})
export class ScrollAnchorDirective {
  @Input() public scrollAnchor:string;

  constructor(
    private scrollService:ScrollService
  ) {
    /**/
  }

  @HostListener('click', ['$event'])
  public onClick(evt: Event):void {
    evt.preventDefault();
    setTimeout(() => this.scrollService.scrollTo(this.scrollAnchor), 50);
  }
}